import styled, { keyframes } from 'styled-components';
import ImageWrapper from '../../../../new-components/ImageWrapper';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { ExpoBannerContainerProps } from '.';
import { useRef, useState } from 'react';
import OnOutsideClick from '../../../../lib/Custom Hooks/onOutsideClick';
import { useSelector } from 'react-redux';

const Banner = ({ handleClose }: ExpoBannerContainerProps) => {
  const { t } = useTranslation('common');
  const { locale } = useRouter();
  const containerRef = useRef<HTMLDivElement>(null);
  const countryCode = useSelector(
    (state: any) => state.app.userLocation?.countryCode
  );

  OnOutsideClick(containerRef, containerRef, handleClose);
  return (
    <Container locale={locale} id="expo-banner">
      <div className="content" id="expo-content-modal" ref={containerRef}>
        <ImageWrapper
          src="assets/images/expo/banner-bg.png"
          alt="expo-banner"
          fill
          style={{ zIndex: -1 }}
        />

        <button className="close-btn" onClick={handleClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="31"
            viewBox="0 0 30 31"
            fill="none"
          >
            <path
              d="M8.81282 8.83333L21.1872 21.2077M21.1872 8.83333L8.81282 21.2077"
              stroke="#212427"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <div className="content-inner">
          <div className="logos-container">
            <ImageWrapper
              src="assets/images/expo/logos.png"
              alt="expo-logos"
              fill
            />
          </div>
          <div className="content-info">
            <span className="location">
              {t(`${countryCode}_expo_location`)}
            </span>
            <span className="date">{t(`${countryCode}_expo_date`)}</span>
            <span className="slogan">{t('expo_slogan')}</span>
          </div>
          <div className="footer-content">
            <div className="info">
              <span className="download">{t('expo_footer_title')}</span>
              <span className="register">{t('expo_footer_subtitle')}</span>
            </div>
            <div className="qr-code">
              <ImageWrapper
                src={`assets/images/expo/${countryCode}-qr-code.svg`}
                alt="expo-qr-code"
                fill
              />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
const fadeAndScale = keyframes<{ locale?: string }>`
  from {
    opacity: 0;
    transform: scale(0.2);
    bottom: -30%;
    inset-inline-end: -50%;
  }
  to {
    opacity: 1;
    transform: scale(1);
    bottom: 0;
    inset-inline-end: 0;
  }
`;
const reverseFadeAndScale = keyframes<{ locale?: string }>`
    from {
      opacity: 1;
      transform: scale(1) ;
      bottom: 0;
      inset-inline-end: 0;
    }
  to {
    opacity: 0;
    transform: scale(0.2) ;
    bottom: -30%;
    inset-inline-end: -50%;
  }
`;

const Container = styled.div<{ locale?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: #000000bf;

  &.remove-overlay {
    background: transparent;
  }
  .content {
    position: relative;
    width: 923px;
    height: 617px;
    padding: 200px 58px 45px;
    transform: scale(1) translate(0, 0);
    opacity: 1;
    animation: ${fadeAndScale} 0.3s linear;

    &.disappear {
      animation: ${reverseFadeAndScale} 0.3s linear;
      opacity: 0;
    }
    .content-inner {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      .logos-container {
        width: 253px;
        height: 35px;
        position: relative;
        margin-bottom: 54px;
        align-self: ${props =>
          props.locale === 'ar' ? 'flex-end' : 'flex-start'};
      }
    }
    .content-info {
      display: flex;
      flex-direction: column;
      margin-right: ${props => (props.locale === 'ar' ? '300px' : '0')};
      span {
        line-height: 150%;
        &.location {
          color: #edf2fa;
          font-family: materialRegular;
          font-size: 23px;
        }
        &.date {
          color: #fff;
          font-family: materialMedium;
          font-size: 40px;
          margin-bottom: 6px;
        }
        &.slogan {
          color: #edf2fa;
          font-family: materialLight;
          font-size: 20px;
        }
      }
    }
    .footer-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: auto;
      .info {
        display: flex;
        flex-direction: column;
        span {
          color: #fff;
          text-transform: capitalize;
          font-size: 26px;
          line-height: ${props => (props.locale == 'ar' ? '46px' : 'normal')};

          &.download {
            font-family: ${props =>
              props.locale == 'ar' ? 'materialMedium' : 'materialSemiBold'};
          }
          &.register {
            font-family: materialRegular;
          }
        }
      }
      .qr-code {
        width: 118px;
        height: 118px;
        position: relative;
        border: 8px solid #8A929A;
        border-radius: 12px;
      }
    }

    .close-btn {
      position: absolute;
      width: 40px;
      height: 40px;
      top: 32px;
      right: 32px;
      cursor: pointer;
      border: none;
      outline: none;
      background-color: #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export default Banner;
